import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';

@Injectable()
export class DeviceHelper {
  public async checkUserDevice(): Promise<string> {
    return (await Device.getInfo()).operatingSystem.toString();
  }
}
